import { RIGHTS } from 'core-uda/Rights'
import { UDA_URL } from 'core-uda/model/ResourceDAO'
import { ADD_UDA_TOKEN, MERCATOR_Y } from './deprecatedLayers.utils'
import { THM_PREF } from 'thm/ThmPreferences'
import { hasYamlRight } from './deprecatedLayers.utils'

function _getCmapTileSizeFromRight() {
  const url = RIGHTS('map.base.cmap.config'),
    right = url.split(':')

  return right[1] || 512
}

export function deprecatedMarineLayer() {
  if (hasYamlRight('marine')) return {}
  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1),
    cmapLayers = THM_PREF.get('cmapLayers'),
    cmapLayersParam = 'S52-Base' + (!!cmapLayers ? ',' + cmapLayers : ''),
    maxZoom = RIGHTS('map.layers.marine.maxZoom', 19) * centerZoomFactor,
    cmapLoadMode = THM_PREF.get('cmapLoadMode'),
    zoomFactor = centerZoomFactor === 1 ? 2 : 1.5,
    layerExtent = [-MERCATOR_Y, -15496570.7397, MERCATOR_Y, 15496570.7397], // Change extent to hide grey header and footer on map
    attributions = '© <a href="https://www.c-map.com">C-MAP</a>',
    url = UDA_URL + 'map/base/cmap?application=umv'

  return {
    type: 'group',
    maxZoom,
    zoomFactor,
    wmsCapabilities: {
      url: '{UDA_URL}map/base/cmap?',
      excludedWmsLayers: ['borders'],
      requiredWmsLayers: ['cmap_base'],
      toUpdateGisLayer: ['marine.cmapTileWMS', 'marine.cmapWMS'],
    },
    data: {
      icon: 'boatAnchor',
    },
    layers: [
      {
        type: 'tileWMS',
        data: {
          id: 'marine.cmapTileWMS',
        },
        url,
        layerExtent,
        projection: 'EPSG:3857',
        maxResolution: 15552, // after zoom level 3 (excluded)
        wrapX: true,
        attributions,
        tileLoadFunction: ADD_UDA_TOKEN,
        maxZoom,
        zoomFactor,
        tileSize: _getCmapTileSizeFromRight(),
        visible: cmapLoadMode === 'tileWMS',
        params: {
          LAYERS: cmapLayersParam,
        },
      },
      {
        url: 'osm-cmap/{z}/{x}/{y}.png',
        data: {
          id: 'marine.osmTileXYZ',
        },
        minResolution: 15552, // before zoom level 3 (included)
        zoomFactor,
        type: 'tileXYZ',
        //no attributions as they are not from C-MAP
      },
      {
        type: 'WMS',
        data: {
          id: 'marine.cmapWMS',
        },
        url,
        layerExtent,
        projection: 'EPSG:3857',
        maxResolution: 15552, // after zoom level 3 (excluded)
        wrapX: true,
        attributions,
        tileLoadFunction: ADD_UDA_TOKEN,
        maxZoom,
        visible: cmapLoadMode === 'WMS',
        zoomFactor,
        params: {
          LAYERS: cmapLayersParam,
        },
      },
    ],
  }
}
